import fr from 'facet-rest';
import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';

const styles = () => ({
  root: {},
});


export function withWhatIfNavigationAndHeader(WrappedTemplate) {
  return withStyles(styles)(({ classes, ...rest }) => {
    const { loadModalCollectionByLink } = useModalContext();

    const {
      resource,
      onSubmit,
      saving,
    } = useMetaLayoutContext();

    const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');

    return (
      <>
        <TitleSection />
        <WrappedTemplate {...rest} />
        <WhatIfStepNavigator
          onNext={() => onSubmit()}
          onPrevious={previousLink ? () => loadModalCollectionByLink(previousLink.url()) : null}
          isLoading={saving}
        />
      </>
    );
  });
}
